export const FIELD_PADDING_X = 15;
export const FIELD_PADDING_Y = 10;
export const FIELD_MARGIN_BOTTOM = 16;
export const FORM_PADDING_X = 25;
export const FORM_PADDING_Y = 25;
